<template>
  <div>
    <form>
      <md-card v-if="user">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div v-if="user.image" class="picture">
            <img :src="user.image" />
          </div>
          <div v-else class="picture">
            <img :src="avatar" />
          </div>
          <input type="file" @change="onFileChange" id="avatarInput" />
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Benutzername</label>
                <md-input v-model="user.displayName" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label for="gender">Geschlecht</label>
                <md-select v-model="user.gender" name="gender" id="gender">
                  <md-option value="male">Männlich</md-option>
                  <md-option value="female">Weiblich</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Vorname</label>
                <md-input v-model="user.firstname" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Nachname</label>
                <md-input v-model="user.lastname" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-datepicker
                :value="stringToDate(user.birthday, 'YYYY.MM.DD', 'DD.MM.YYYY')"
                @input="updateBirthday"
              >
                <label>Geburtsdatum</label>
              </md-datepicker>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Gewicht</label>
                <md-input v-model="user.weight" type="number"></md-input>
                <b>kg</b>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <p class="text-info">
                Wenn du deine Adresse angibst, kann diese bei Challenges
                automatisch ausgefüllt werden, ansonsten verwenden wir diese
                Daten nicht!
              </p>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Straße</label>
                <md-input v-model="user.street" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-25">
              <md-field>
                <label>Adresszusatz</label>
                <md-input v-model="user.streetNumber" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-25">
              <md-field>
                <label>Postleitzahl</label>
                <md-input v-model="user.zip" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Ort</label>
                <md-input v-model="user.city" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label for="country">Land</label>
                <md-select v-model="user.country" name="country" id="country">
                  <md-option value="at">Österreich</md-option>
                  <md-option value="de">Deutschland</md-option>
                  <md-option value="ch">Schweiz</md-option>
                  <md-option value="bel">Belgien</md-option>
                  <md-option value="bulg">Bulgarien</md-option>
                  <md-option value="dk">Dänemark</md-option>
                  <md-option value="est">Estland</md-option>
                  <md-option value="fin">Finnland</md-option>
                  <md-option value="fr">Frankreich</md-option>
                  <md-option value="gr">Griechenland</md-option>
                  <md-option value="uk">Großbritannien</md-option>
                  <md-option value="irl">Irland</md-option>
                  <md-option value="it">Italien</md-option>
                  <md-option value="kr">Kroatien</md-option>
                  <md-option value="latv">Lettland</md-option>
                  <md-option value="lie">Liechtenstein</md-option>
                  <md-option value="lit">Litauen</md-option>
                  <md-option value="lux">Luxemburg</md-option>
                  <md-option value="malt">Malta</md-option>
                  <md-option value="nl">Niederlande</md-option>
                  <md-option value="nor">Norwegen</md-option>
                  <md-option value="pl">Polen</md-option>
                  <md-option value="port">Portugal</md-option>
                  <md-option value="rum">Rumänien</md-option>
                  <md-option value="se">Schweden</md-option>
                  <md-option value="sk">Slowakei</md-option>
                  <md-option value="slo">Slowenien</md-option>
                  <md-option value="esp">Spanien</md-option>
                  <md-option value="cz">Tschechien</md-option>
                  <md-option value="hu">Ungarn</md-option>
                  <md-option value="cy">Zypern</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50" v-if="this.$store.getters.isAdmin">
              <md-field>
                <label>{{$t('general.language')}}</label>
                <md-select v-model="user.language">
                  <md-option
                      v-for="locale in locales"
                      :key="locale"
                      :label="locale"
                      :value="locale"
                  >
                    {{$t(`locale.${locale}`)}}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100 text-right">
              <md-button class="md-raised md-success mt-4" @click="update"
                >Bestätigen</md-button
              >
            </div>
          </div>
        </md-card-content>
        <md-card-actions v-if="isDev">
          <md-button class="md-raised md-success mt-4" @click="testMsg(false)"
            >new</md-button
          >
          <md-button class="md-raised md-success mt-4" @click="testMsg(true)"
            >push</md-button
          >
        </md-card-actions>
      </md-card>
      <md-progress-spinner v-else md-mode="indeterminate"></md-progress-spinner>
    </form>
    <br/>

    <router-link to="/pages/settings" class="my-apps-button"
      ><md-button class="md-primary">Meine Apps</md-button></router-link
    >
    <router-link to="/pages/friends" class="my-friends-button"
      ><md-button class="md-primary">Meine Freunde</md-button></router-link
    >
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  name: "edit-profile-form",
  props: {
    avatar: {
      type: String,
      default: "https://images.sports4me.at/img/default-avatar.png"
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      isAdmin: state => state.isAdmin || false,
      isDev: state => state.isDev || false
    })
  },
  mounted() {
    this.routerId = this.$route.params.id;
  },
  data() {
    return {
      locales: ['en', 'de'],
      routerId: '',
    }
  },
  methods: {
    stringToDate(string, input, output) {
      return moment(string, input).format(output);
    },
    testMsg(push) {
      this.$store.dispatch("testNotification", { push: push }).then(() => {
        console.log("User loaded");
      });
    },
    loadUser() {
      this.$store.dispatch("getUser").then(() => {
        console.log("User loaded");
      });
    },
    formatDate(date, type) {
      return format(date, type);
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var formData = new FormData();
      formData.append("avatar", files[0]);

      this.$store
        .dispatch("uploadAvatar", formData)
        // .then(res => {
        //   // if (res.url) this.user.image = res.url;
        //   // this.loadUser();
        // })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error"
          });
        });
    },
    update() {
      let user = {};
      user.displayName = this.user.displayName || null;
      user.email = this.user.email || null;
      user.firstname = this.user.firstname || null;
      user.lastname = this.user.lastname || null;
      // user.image = this.user.image || null; // this override the uploaded image
      user.birthday = this.user.birthday || null;
      user.gender = this.user.gender || null;
      user.country = this.user.country || null;
      user.weight = this.user.weight || null;
      user.street = this.user.street || null;
      user.streetNumber = this.user.streetNumber || null;
      user.zip = this.user.zip || null;
      user.city = this.user.city || null;
      user.language = this.user.language || null
      this.$store
        .dispatch("updateUser", user)
        .then(res => {
          if (this.$i18n.locale !== user.language ) {
            this.$i18n.locale = user.language;
          }
          this.$notify({
            timeout: 5000,
            message: "Dein Profil wurde geupdated!",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(err => {
          console.error(err);
          this.$notify({
            timeout: 5000,
            message: err.message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error"
          });
        });
    },
    updateBirthday(val) {
      this.user.birthday = val
        ? this.stringToDate(val, "DD.MM.YYYY", "YYYY-MM-DD")
        : null;
      // console.log("Change to: ", this.user.birthday);
      this.birthday = val;
    }
  }
};
</script>
<style lang="scss" scoped>
#avatarInput {
  cursor: pointer;
  display: block;
  height: 120px;
  left: calc(50% - 60px);
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 120px;
}
.picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 4px solid #cccccc;
  color: #ffffff;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
  display: inline-block;
  max-width: 150px;
}

.title {
  align-items: flex-start;
}
.my-apps-button {
  margin-right: 10px;
}
.my-friends-button {
  margin-left: 10px;
}
</style>
